import axios from "axios";
import { update_all_customer_list, update_filtered_customer_Full_list, update_filtered_customer_list } from "../../Redux/Customer/allCustomerListSlice";
import { get_all_customer_Filter } from "../../Redux/Customer/allCustomerListWithFilterSlice";
import store from "../../Redux/store";
import { HEADERS } from "../UrlAndPaths";
import { setCustomerLoading } from "../../component/Modules/Sales/Billing/Components/topBarSliceBilling";

//view all Customers API
export const viewAllCustomersAPICall = async (body,setIsLoading) => {
  setIsLoading!==undefined && setIsLoading(true)
  await axios
    .post("customer/viewCustomer", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        store.dispatch(update_all_customer_list({ customerList: res.data }));
        setIsLoading!==undefined && setIsLoading(false)

      }
    })
    .catch((err) => {
      store.dispatch(update_all_customer_list({ customerList: undefined }));
      setIsLoading!==undefined && setIsLoading(false)

    });
};
export const CustomersFilterAPICall = (body, setIsLoading) => {
  if (setIsLoading) setIsLoading(true);

  // 1. Call without download (for paginated/filtered list)
  axios.post("customer/searchCustomer", { ...body, download: false }, {
    headers: { 'Content-Type': 'application/json' },
  })
  .then((res) => {
    if (res.status === 200) {
      store.dispatch(update_filtered_customer_list({ filterCustomer: res.data }));
    }
  })
  .catch(() => {
    store.dispatch(update_filtered_customer_list({ filterCustomer: undefined }));
  });

  // 2. Call with download: true (for full list)
  axios.post("customer/searchCustomer", { ...body, download: true }, {
    headers: { 'Content-Type': 'application/json' },
  })
  .then((res) => {
    if (res.status === 200) {
      store.dispatch(update_filtered_customer_Full_list(res.data ));
    }
    if (setIsLoading) setIsLoading(false);
  })
  .catch(() => {
    store.dispatch(update_filtered_customer_Full_list({undefined }));
    if (setIsLoading) setIsLoading(false);
  });
};

//get search all customer 
export const customerListApi = async (body)=>{
  store.dispatch(setCustomerLoading(true))
  try {
    const response = await axios.post("account/viewCustomerForDropdown", body, HEADERS)
    if(response.status === 200){
      store.dispatch(update_all_customer_list({ customerList: response.data }));
      store.dispatch(setCustomerLoading(false))
    }
  } catch (error) {
    console.error(error.message)
    store.dispatch(setCustomerLoading(false))
    store.dispatch(update_all_customer_list({ customerList: undefined }));
  }
}

// view all customer with filter
export const viewAllCustomerWithFilterAPICall = async (
  body,
  setIsLoading,
  setErrorSnack,
  setSnackMsg
) => {
  if (setIsLoading !== undefined) setIsLoading(true);
  await axios
    .post("customer/viewCustomerwithfilter", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        store.dispatch(
          get_all_customer_Filter({ allCustomerFilterData: res.data })
        );
        if (setIsLoading !== undefined) setIsLoading(false);
      }
    })
    .catch((err) => {
      store.dispatch(
        get_all_customer_Filter({ allCustomerFilterData: undefined })
      );
      console.log(err.response);
      switch (err.response.status) {
        case 404:
          setSnackMsg("No data available..");
          break;
        case 500:
          setSnackMsg("Server error!!");
          break;
        case 401:
          setSnackMsg("Unauthorized!!");
          break;
        case 403:
          setSnackMsg("Forbidden!!");
          break;

        default:
          setSnackMsg(
            "Unseen error occurred,Please contact to EYET Support!!!!"
          );
          break;
      }
      setErrorSnack(true);
      if (setIsLoading !== undefined) setIsLoading(false);
    });
};








